/* file description */

import { isArray } from 'lodash';
import { RetrunValType } from './templates/Cascade/type';

const createVal = (arr: any[], argu?: Record<string, any>) => {
  return arr.map((item, index) => {
    return {
      _id: `${index}`,
      ...argu,
      ...item.value,
    };
  });
};

const setValue = (
  data: Record<string, any>,
  obj: any,
  key: string,
  argu = {},
) => {
  if (data[key] && isArray(data[key])) {
    data[key] = data[key].concat(createVal(obj.record, argu));
  } else {
    data[key] = createVal(obj.record, argu);
  }
};

const getDefaultByModuleInfo = (module: {
  fields: Array<{ name: string }>;
}) => {
  const defaultValue: any = {};
  (module?.fields || []).forEach((f) => {
    defaultValue[f.name] = null; // 必须为null，否则jsonata无法匹配到
  });
  return defaultValue;
};

export const cascadeTransformValues = (
  response: RetrunValType,
  moduleList: any[],
) => {
  const dataSouces: Record<string, any> = {};
  // 头
  dataSouces[response.modelId] = {
    ...getDefaultByModuleInfo(
      moduleList.find((x) => x.handle === response.modelId),
    ),
    ...response.record[0]?.value,
  };

  response.record[0].children?.forEach((seItem) => {
    setValue(
      dataSouces,
      seItem,
      seItem.modelId,
      getDefaultByModuleInfo(
        moduleList.find((x) => x.handle === seItem.modelId),
      ),
    );
    seItem.record.forEach((thItem, tIndex) => {
      thItem.children?.forEach((fItem) => {
        setValue(dataSouces, fItem, fItem.modelId, {
          _headId: `${tIndex}`,
          ...getDefaultByModuleInfo(
            moduleList.find((x) => x.handle === fItem.modelId),
          ),
        });
      });
    });
  });

  return dataSouces;
};


export const valueReplace = (text = '', data: Record<string, any>, rowIndex = 0) => {
  const VALTEMPLATEREG = /\$\{(.*?)\}/g;
  const NULLREPLACE = 'ERROR';
  const tableTranform = text.replace(VALTEMPLATEREG, (...args) => {
    const expr = args[1];
    const [moduleName, fieldName] = expr.split('.');
    if (!isArray(data?.[moduleName])) {
      return data?.[moduleName]?.[fieldName] || NULLREPLACE;
    }
    return data?.[moduleName]?.[rowIndex]?.[fieldName] || NULLREPLACE;
  });
  return tableTranform;
};


export const getCopyMapField = (copyMap: Record<string, any>) => {
  const targetMapModuleField: Record<string, any> = {};
  copyMap?.fieldMappingList?.forEach((moduleMap) => {
    const fieldList = moduleMap.relation.map((rel) => {
      return rel.target.name;
    });
    targetMapModuleField[moduleMap.targetModule] = fieldList;
  });
  return {
    targetMapModuleField,
  };
};


// export const createExclusiveConfig = (pageConfig: PageConfigType, pageType: pageStatusType) => {
//   if (pageType === 'add' || pageType === 'edit') {
//     return pageConfig?.createPageConfig || {};
//   }
//   if (pageType === 'view') {
//     return pageConfig?.detailPageConfig || {};
//   }
//   if (pageType === 'list') {
//     return pageConfig?.listPageConfig || {};
//   }
// };
